<template>
    <page>
        <module enable-flex>
            <!-- 视图化列表组件（work_type=5501 会员管理） -->
            <view-list ref="view" :work-type="workType" :view-config="saasInfo.viewmanage">
                <!-- 搜索栏 -->
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="昵称">
                            <c-input name="nickname" maxlength="20" placeholder="请输入昵称"></c-input>
                        </m-search-item>
                        <m-search-item label="手机号码">
                            <c-input name="phone" maxlength="11" placeholder="请输入手机号码"></c-input>
                        </m-search-item>
                        <m-search-item label="状态">
                            <c-checkbox-group name="states" :options="disableEnableDic"></c-checkbox-group>
                        </m-search-item>
                        <m-search-item label="注册时间" colspan="2">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <!-- 操作按钮区 -->
                <template #operate>
					<c-button v-if="auth('b_member_export')"
							  prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出
					</c-button>
                </template>

                <!-- 操作列（固定右侧，通过默认插槽注入静态列） -->
<!--                <c-table-column type="button" label="操作" width="140" fixed="right" button-limit="2">-->
<!--                    <template #default="{data}">-->
<!--                        <c-table-button v-if="auth('b_member_edit')" icon="tf-edit" @click="$refs.memberEdit.open(data)">编辑</c-table-button>-->
<!--                    </template>-->
<!--                </c-table-column>-->

                <!-- 状态列：启用/禁用开关 -->
                <template #state="{data}">
                    <c-switch v-model="data.state" :state-value="[1, 2]"
                              :state-text="['启用','禁用']"
                              @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
                </template>

                <!-- 性别列：文字展示 -->
                <template #gender="{data}">
                    <c-state dict="PUBLIC_GENDER" async :value="data.gender"></c-state>
                </template>

                <template #balance="{data}">
                    <span>￥{{data.balance}}</span>
                </template>

                <template #deposit_balance="{data}">
                    <span>￥{{data.deposit_balance}}</span>
                </template>

                <template #is_vip="{data}">
					<c-state dict="enableDic" :value="data.is_vip"></c-state>
                </template>
            </view-list>

            <!-- 新增/编辑会员弹窗 -->
            <member-edit ref="memberEdit" @resolve="$refs.view.update()"></member-edit>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import memberEdit from "@/pages/mall/member_edit.vue";
import CState from "../../components/public/state.vue";

export default {
    name: 'm_member',

    components: {
		CState,
        memberEdit
    },

    computed: {
        ...mapState(['disableEnableDic', 'saasInfo'])
    },

    data() {
        return {
            /* 视图业务类型（5501=会员管理，对应 TBL_SYS_WORK_TYPE.id） */
            workType: 5501,
        }
    },

    methods: {
        /******会员启禁用*********/
        stateHandle(state, next, data) {
            this.request({
                url: '/mall/member/update_state',
                data: {
                    id: data.id,
                    state: state ? 2 : 1
                },
                success: () => {
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    next();
                }
            });
        },

        /******删除会员***********/
        removeMember(data) {
            this.$confirm({
                message: '确认删除会员【' + data.member_name + '】？删除后不可恢复',
                buttonName: '确定',
                cancelButton: true,
                resolve: () => {
                    this.request({
                        url: '/mall/member/delete',
                        data: {id: data.id},
                        loading: true,
                        success: () => {
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                            this.$refs.view.update();
                        }
                    });
                },
                cancel: () => {
                },
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>
